import React from "react";
import { createRoot } from "react-dom/client";
import Observability from "@launchdarkly/observability";
import SessionReplay from "@launchdarkly/session-replay";
import { withLDProvider } from "launchdarkly-react-client-sdk";

import App from "./App.tsx";
import "./index.css";

const clientSideID = import.meta.env.VITE_LAUNCHDARKLY_CLIENTSIDEID;
if (!clientSideID) {
  console.error(
    "LaunchDarkly client-side ID is not set. Please set VITE_LAUNCHDARKLY_CLIENTSIDEID in your .env file and restart the server."
  );
}

const LDProvider = withLDProvider({
  clientSideID: clientSideID,
  options: {
    plugins: [
      new Observability({
        networkRecording: {
          enabled: true,
          recordHeadersAndBody: true,
        },
      }),
      new SessionReplay({
        // Defaults to no obfuscation - see https://docs.launchdarkly.com/sdk/features/client-side-observability#privacy for more details
        privacySetting: "none",
      }),
    ],
  },
});

const AppWithLD = LDProvider(App);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppWithLD />
  </React.StrictMode>
);
